import { initReadMoreToggle } from '../helpers/init_read_more_toggle'

/**
 * take a message and update it immediately or wait a second and try again
 */
export function updateChannelContent(socket, targetSelector, iteration, id) {
  const element = document.getElementById(targetSelector);
  const chatId = id || element?.dataset.chatSessionUuid;

  // If we have a chatId, subscribe immediately even if the DOM element is not yet present.
  if (chatId) {
    // Avoid duplicate subscriptions for the same socket + chat id
    if (socket.__benchmateSubscribedFor === chatId) { return; }
    const channelMsg = {
      command: 'subscribe',
      identifier: JSON.stringify({
        channel: 'BenchmateChatsChannel',
        session_uuid: chatId
      }),
    };
    socket.send(JSON.stringify(channelMsg));
    socket.__benchmateSubscribedFor = chatId;
    return;
  }

  // If no element and no id yet, keep retrying a bit longer to survive heavy renders
  if (!element) {
    if (iteration > 60) {
      // eslint-disable-next-line no-console
      console.error("updateChannelContent error - tried too many times.", iteration);
      return;
    }
    setTimeout(() => {
      updateChannelContent(socket, targetSelector, iteration + 1, id);
    }, 500);
    return;
  }

  // Element exists but no chatId found on it yet — try again shortly
  setTimeout(() => {
    updateChannelContent(socket, targetSelector, iteration + 1, id);
  }, 250);
}
window.updateChannelContent = updateChannelContent;

/**
 * Handle progressive content updates
 */
function handleProgressiveUpdate(data) {
  const targetElement = document.getElementById('search-overview');
  if (!targetElement) return;

  const updateContent = function (targetElement, data) {
    targetElement.innerHTML = data.html;
    initReadMoreToggle(); // ensure toggle active after streaming update

    // Handle streaming indicators and scroll
    const newElement = document.getElementById('benchmate_chats');

    if (newElement) {
      // Auto-scroll if user was at bottom
      const container = newElement.closest('.overflow-auto, .scroll-container');
      if (container) {
        const shouldAutoScroll = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;
        if (shouldAutoScroll) {
          container.scrollTop = container.scrollHeight;
        }
      }
    }
  }

  switch (data.action) {
    case 'show_waiting':
    case 'update_content': {
      updateContent(targetElement, data);
      break;
    }
    case 'error': {
      const errorElement = document.getElementById('benchmate_chats');
      if (errorElement) {
        errorElement.innerHTML = '<div class="alert alert-danger">' + data.html + '</div>';
      } else {
        targetElement.innerHTML = data.html;
      }
      break;
    }
  }
}

/**
 * Subscribe to benchmate channel immediately when session UUID is available
 */
function subscribeToChannel(socket) {
  const sessionUuid = document.getElementById('ws-connection')?.dataset.chatSessionUuid;

  if (sessionUuid) {
    updateChannelContent(socket, 'search-overview', 0, sessionUuid);
  }
}

/**
 * createWebSocket with enhanced message handling
 */
export function createBenchmateSocket(url) {
  var socket = new WebSocket(url);
  socket.binaryType = htmx.config.wsBinaryType;
  window.htmx.activeSocket = socket;

  socket.onmessage = function (event) {
    const response = event.data;
    const msg = JSON.parse(response);

    // Handle welcome message - subscribe immediately since session UUID is in DOM
    if (msg.type === "welcome") {
      subscribeToChannel(socket);
      return event;
    }

    // Handle ActionCable messages with progressive updates
    if (msg.message && msg.message.html) {
      handleProgressiveUpdate(msg.message);
    }

    return event;
  };

  return socket;
}
